module.exports = __webpack_public_path__ + "img/18.f621de34.png";